<template>
	<b-card no-body>
        
        <b-modal id="create-or-update" :title="editing ? 'Güncelle' : 'Oluştur'" no-close-on-esc no-close-on-backdrop>
            <brand-model-serial-create-or-update v-model="brandModelSerial" :errors="errors"></brand-model-serial-create-or-update>
            <template #modal-footer><v-executer :loading="loading" :editing="editing" :action="createOrUpdate"></v-executer></template>
        </b-modal>

        <v-table    ref="table"
                    :add-callback="createNew"
                    :fields="fields"
                    name="brand-model2"
                    :buttons="buttons"
                    pagination = "server"
                    search
                    :items-provider="provider"></v-table>
    </b-card>
</template>

<script>
import {BCard,} from 'bootstrap-vue'
import BrandModelSerialCreateOrUpdate from './components/BrandModelSerialCreateOrUpdate.vue'
import VehicleDefinitionsApi from '@/api/vehicle-definitions'

export default {
	components:{
        BCard,
        BrandModelSerialCreateOrUpdate
	},
	data(){
		return{
			editing:false,
            errors:{},
            loading:false,
            brandModelSerial:{
                Id:null,
                Name:null,
                VehicleBrandId:null,
                VehicleBrandModelId:null,
            },
            fields:[
                { name:"Marka",key:"VehicleBrandName", thClass:"w-50",sortable:true,sortKey:'VehicleBrandModel.VehicleBrand.Name'},
                { name:"Model",key:"VehicleBrandModelName", thClass:"w-25",sortable:true,sortKey:'VehicleBrandModel.Name'},
                { name:"Seri",key:"Name", thClass:"w-25",sortable:true,},
            ],
            buttons:[
                { text:"Düzenle",key:"edit",icon:"Edit2Icon",variant:"secondary",action:this.edit },
                { text:"Sil",key:"delete",icon:"TrashIcon",variant:"danger",action:this.delete },
            ]
		}
	},
	methods:{
		clearForm(){
            this.editing = false
            this.brandModelSerial.Id = null
            this.brandModelSerial.Name = null
            this.brandModelSerial.VehicleBrandId = null
            this.brandModelSerial.VehicleBrandModelId = null
        },
        createNew(){
            this.clearForm()
            this.$showModal('create-or-update')
        },
        edit(item){
            this.clearForm()
            this.editing = true
            this.brandModelSerial.Id = item.Id
            this.brandModelSerial.Name = item.Name
            this.brandModelSerial.VehicleBrandId = item.VehicleBrandId
            this.brandModelSerial.VehicleBrandModelId = item.VehicleBrandModelId
            this.$showModal('create-or-update')
        },
        provider(data){
            return VehicleDefinitionsApi.BrandModelSerial.Table(data)
        },
        createOrUpdate(){
            this.loading = true
            VehicleDefinitionsApi.BrandModelSerial.CreateOrUpdate(this.editing,this.brandModelSerial)
            .then(res=>{
                if(res.data.Success) {
                    this.$refs.table.refresh()
                    this.clearForm()
                    this.$hideModal('create-or-update')
                }
                this.$result(res)
                this.loading = false
            })
            .catch(err=>{
                this.$result(null,err)
                this.loading = false
            })
        },
        delete(item){
            this.$confirm('Silmek istediğinize emin misiniz?',`Bu işlem ${item.Name} serisini silecektir ve geri alınamaz.`).then(result=>{
                if(result){
                    VehicleDefinitionsApi.BrandModelSerial.Delete(item.Id).then(res=>{
                        if(res.data.Success) {
                            this.$refs.table.refresh()
                        }
                        this.$result(res)
                    }).catch(err=>{
                        this.$result(null,err)
                    })
                }
            })
        }
	}
}
</script>

<style>

</style>